import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders } from '@angular/common/http';
import { Router,ActivatedRoute } from '@angular/router';
import { ConstantConfigService } from '../services/constant-config.service';
import { DataService } from '../services/data.service';
import { Observable, throwError } from 'rxjs';
import { retry, catchError,tap,switchMap  } from 'rxjs/operators';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import 'rxjs/add/operator/do';
import { BehaviorSubject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { truncateSync } from 'fs';

function isPdf(buffer: ArrayBuffer): boolean {
  if (!buffer || buffer.byteLength < 5) {
    return false;
  }
  const view = new DataView(buffer);
  const signature = String.fromCharCode(
    view.getUint8(0), view.getUint8(1), view.getUint8(2), view.getUint8(3), view.getUint8(4)
  );
  return signature === '%PDF-';
}

@Injectable({
  providedIn: 'root'
})
export class GeneralService {
  _baseURL : string;
	_imageURL : string;
	_accessToken : string;

    constructor(
      private http: HttpClient,
      private router: Router,
      private route: ActivatedRoute,
      private toastr: ToastrService,
      public dataService: DataService,
    ) {
      this._baseURL = ConstantConfigService.baseURL;
      this._imageURL = ConstantConfigService.ImageUrl;
      this._accessToken = ConstantConfigService.accessToken;
    }

    showToasterSuccessMessage(message){
      this.toastr.clear();

      this.toastr.success(message,'', {
        positionClass: 'toast-top-center',
        closeButton:true,
	      timeOut:10000,
      });
      // Success
    }

    showToasterInfoMessage(message,title?){
      this.toastr.clear();
      let heading_title = '';
      if(typeof title !='undefined' && title == 1){
        heading_title = 'Warning';
      } else {
        heading_title = 'Info';
      }
      this.toastr.info(message,heading_title, {
        positionClass: 'toast-top-center',
        closeButton:true,
	      timeOut:10000
      });
    }

    showToasterErrorMessage(message,title?, isYellow = false){
 
      const chunkFailedMessage = /Loading chunk/;
      if (chunkFailedMessage.test(message)) {
        window.location.reload();
      } else {
        this.toastr.clear();
        let heading_title = '';
        if(typeof title !='undefined' && title == 1){
          heading_title = 'Warning';
        } else {
          heading_title = 'Error';
        }
 
        const toastOptions = {
          positionClass: 'toast-top-center',
          closeButton: true,
          timeOut: 10000,
          ...(isYellow && { toastClass: 'ngx-toastr toast-warning-yellow' })
        };
 
        if(heading_title == 'Error') {
          heading_title = '';
          this.toastr.error(message, heading_title, toastOptions);
        } else {
          this.toastr.error(message, heading_title, toastOptions);
        }
 
        // if(heading_title == 'Error'){
        //   heading_title = '';
        //   this.toastr.error(message,heading_title, {
        //     positionClass: 'toast-top-center',
        //     closeButton:true,
        //     timeOut:10000
        //   });
        // } else {
        //   this.toastr.error(message,heading_title, {
        //     positionClass: 'toast-top-center',
        //     closeButton:true,
        //     timeOut:10000
        //   });
        // }
 
      }
 
    }

    showGeneralErrorMessage(){

    }


    // Get Role Privilages
    getRoles(){
      return this.http.get(this._baseURL+"/getRoles");
    }

    // Post Role Privilages
	  getUserPasswordHashed(roleId,privilegeHeadings,check){
  		return this.http.post(this._baseURL+"/updateUserPrivilege",{'role':roleId,'privilege':privilegeHeadings,'is_checked':check});
  	}

    async getHashToken(){
      return await this.http.get(this._baseURL+"/template/gethashToken").toPromise();
    }

    openSigningHash(timehash,hashKey,docComment){
      if(timehash == null || timehash == '' || typeof  timehash == 'undefined'){
        return this.http.get(this._baseURL+"/template/signing/spec/"+hashKey+"/"+docComment);
      } else {
        return this.http.get(this._baseURL+"/template/signing/"+timehash+"/"+hashKey+"/"+docComment);
      }
    }

    openSigningHashv1(timehash,hashKey,docComment,savedsignature=false,saveduserid=0,loaduserdata=0){
      if(timehash == null || timehash == '' || typeof  timehash == 'undefined'){
        return this.http.get(this._baseURL+"/template/signing/spec/"+hashKey+"/"+docComment+"/"+loaduserdata+"/"+savedsignature+"/"+saveduserid);
      } else {
        return this.http.get(this._baseURL+"/template/signing/"+timehash+"/"+hashKey+"/"+docComment+"/"+loaduserdata+"/"+savedsignature+"/"+saveduserid);
      }
    }

    openSigning(timehash,hashKey,docComment){
      if(timehash == null || timehash == '' || typeof  timehash == 'undefined'){
        return this.http.get(this._baseURL+"/template/open-sign/spec/"+hashKey+"/"+docComment);
      } else {
        return this.http.get(this._baseURL+"/template/open-sign/spec/"+hashKey+"/"+docComment+"/"+timehash);
      }
    }

    getCompanyStripeKeys(postData){
      return this.http.post(this._baseURL+"/get-company-stripe-keys",postData);
    }

    getUserCreditCards(postData){
        return this.http.post(this._baseURL+"/get-company-based-cards",postData);
    }

    openHubSpotFieldApprovalHash(hashtype,timehash,hashKey){
      return this.http.get(this._baseURL+"/hubspotfieldapproval/"+hashtype+"/"+timehash+"/"+hashKey);
    }

    updateHubSpotFieldApprovalHash(hashtype,hashKey){
      return this.http.get(this._baseURL+"/hubspotfieldupdateapproval/"+hashtype+"/"+hashKey);
    }

    getHubSpotPrefillProperties(hashKey){
      return this.http.get(this._baseURL+"/gethubSpotprefillproperties/"+hashKey);
    }

    updatehubspotselectedproperties(hashKey){
      return this.http.post(this._baseURL+"/update-selected-hubspot-properties",{'hash':hashKey});
    }
    updateSelectedData(postData){
      return this.http.post(this._baseURL+"/update-selected-hubspot-properties",postData);
    }

    // Reject a request
	  rejectRequestWithMessage(hash,reject_message){
  		return this.http.post(this._baseURL+"/sign/reject",{'hash':hash,'reason':reject_message,'ng-7':'true'});
    }

    updateStep(postData){
      return this.http.post(this._baseURL+"/updateSigningStep",postData);
    }

    sendSecureLinkMessage(postData){
      return this.http.post(this._baseURL+"/sendSecureLinkMessage",postData);
    }

    saveBlockWithoutToken(postData){
      return this.http.post(this._baseURL+"/prepare-template/save_signing_blocks_without_token_queue",postData);
    }

    getProcessRequest(processId){
      return this.http.get(this._baseURL+'/process_data/'+processId);
    }

    getBillingProductData(billingProductId){
      return this.http.get(this._baseURL+'/product_info/'+billingProductId);
    }

    checkPaymentStatus(processId){
      return this.http.get(this._baseURL+'/check-payment-status/'+processId+'/1');
    }

    approveRequest(postData){
      return this.http.post(this._baseURL+"/sign/approve",postData);
    }

    updateRequestStatus(postData){
      return this.http.post(this._baseURL+"/updateRequestStatus",postData);
    }

    decodeHash(postData){
      return this.http.post(this._baseURL+"/decodeHash",postData);
    }

    updateReverseStep(postData){
      return this.http.post(this._baseURL+"/updateReverseStep",postData);
    }

    addRejectReason(postData){
      return this.http.post(this._baseURL+"/reject_doc_upload",postData);
    }

    sendNotificationToCompany(postData){
      return this.http.post(this._baseURL+"/reject_notification",postData);
    }

    getViewSampleDocument(documentId){
      return this.http.get(this._baseURL+'/viewDocumentDetail/'+documentId);
    }

    getPreviewDocument(user_doc_id){
      return this.http.get(this._baseURL+'/viewPreviewDocument/'+user_doc_id);
    }

    openPaymentReverse(postData){
      return this.http.post(this._baseURL+"/getUpdateDocumentNotes",postData);
    }

    registration(first_name, middle_name, last_name,email,title,password){
      return this.http.post(this._baseURL+"/register-user",{'full_name':first_name,'first_name' :first_name, 'middle_name' :middle_name, 'last_name' :last_name,'email' :email,'title' :title,'password' :password});
    }

    verifyUser(hash){
      return this.http.post(this._baseURL+"/verify-user", {'hash' :hash});
    }

    getSecurityByProcess(processId,userId,userEmail){
      return this.http.get(this._baseURL+'/security-process/'+processId+'/'+userId+'/'+userEmail);
    }

    sendSmsOtpToUser(phone, email, phoneCode,is_signee="0",process_id="",loginrequest='',companyid=''){
      return this.http.post(this._baseURL+"/sentSmsOtp", {"phone":phone, "email":email, "phoneCode":phoneCode,"is_signee":is_signee,"process_id":process_id,'loginrequest':loginrequest,'companyid':companyid});
    }

    sendSmsOtpToUserSecurity(phone, email, phoneCode,is_signee="0",process_id="",loginrequest='',companyid='',emailinfo=''){
     /* return this.http.post(this._baseURL+"/sentSmsOtpSecurity", {"phone":phone, "email":email, "phoneCode":phoneCode,"is_signee":is_signee,"process_id":process_id,'loginrequest':loginrequest,'companyid':companyid,'emailinfo':emailinfo});*/
      let userid = email[0].user_id;
      let emailadd = email[0].email;
     return this.http.get(this._baseURL+'/resend-otp/'+process_id+'/'+userid+'/'+emailadd);

    }

    resendEmailToUserToken(data){
      return this.http.post(this._baseURL+"/resendEmailOtpExcludeToken", data);
    }

    VerifyOtp(data){
      return this.http.post(this._baseURL+"/security-verify-otp", data);
    }

    contactRequestor(data){
      return this.http.post(this._baseURL+"/contact_requestor", data);
    }

    contactRequestorForExtension(data){
      return this.http.post(this._baseURL+"/contact-requestor-for-extension", data);
    }

    reactivateRequestExpirationTime(hashKey){
      return this.http.get(this._baseURL+"/expiration-extension-approval/"+hashKey);
    }

    getCompanySignee(company_id){
      return this.http.get(this._baseURL+'/company/signee/'+company_id);
    }

    getSampleDocsCompany(company_id){
      return this.http.get(this._baseURL+'/getSampleDocumentCompany/'+company_id);
    }

    getTeamListingCompany(company_id){
      return this.http.get(this._baseURL+'/getTeamListing/'+company_id);
    }

    getApprovalUserList(company_id){
      return this.http.get(this._baseURL+'/getApprovalListing/'+company_id);
    }

    getCompanyUsersByType(company_id){
      return this.http.get(this._baseURL+'/getCompanyUsersByType/'+company_id);
    }

    uploadsamplepdf(postData,comapny_id){
      return this.http.post(this._baseURL+"/company/"+comapny_id+"+document/uploadsamplepdf", postData);
    }

	  verifySecondaryEmail(hash){
      return this.http.post(this._baseURL+"/verifySecondaryEmail", {"hash":hash});
    }

    getDocumentData(hash,dealId){
      if(typeof dealId=="undefined"){
        dealId="0";
      }

      return this.http.get(this._baseURL+'/edit-template-detail/'+ hash+'/'+dealId+'/0');
    }

    getDocumentDatav1(hash,dealId,quoteNo,action_panel?){
      if(typeof dealId=="undefined"){
        dealId="0";
      }
      if(typeof action_panel=="undefined"){
        action_panel=0;
      }

      if(typeof quoteNo == "undefined"){
        quoteNo="0";
      }
      return this.http.get(this._baseURL+'/edit-template-detail/'+ hash+'/'+dealId+'/'+quoteNo+'/'+action_panel);
    }

    async getDocumentDatav2(hash,dealId,quoteNo){
      if(typeof dealId=="undefined"){
        dealId="0";
      }

      if(typeof quoteNo == "undefined"){
        quoteNo="0";
      }
      return await this.http.get(this._baseURL+'/edit-template-detail/'+ hash+'/'+dealId+'/'+quoteNo).toPromise();
    }



    getDocumentFormData(hashKey){
      return this.http.get(this._baseURL+"/get-document-data/"+hashKey);
    }

    updateTemplate(postData){
      return this.http.post(this._baseURL+"/template/updateEdit", postData);
    }

    getSignCompanyInfo(id){
      return this.http.get(this._baseURL+'/get-company-header/'+id);
    }

    getCompanyHashedUser(hash){
      return this.http.post(this._baseURL+"/decodeHashRegister", {"hash":hash});
    }

    handleThirdPartyRequests(data){
      return this.http.post(this._baseURL+"/handle-third-party-requests",data);
    }

    resendVerificationEmail(email){
      return this.http.post(this._baseURL+"/register-verification-email-resend", {"email":email});
    }

    completeProcess(data){
      return this.http.post(this._baseURL+"/complete-process", data);
    }

    paymentViaPayPal(postData){
      return this.http.post(this._baseURL+"/do-pp-payments", postData);
    }

    getUserCCInfoByCompany(email,companyid){
      return this.http.get(this._baseURL+"/user-cc-info-by-company/"+email+'/'+companyid);
    }

    doStripePayment(postData){
      return this.http.post(this._baseURL+"/do-payments", postData);
    }

    makeRequestPayment(postData){
      return this.http.post(this._baseURL+"/make-request-payment", postData);
    }

    applyPromoCode(postData){
      return this.http.post(this._baseURL+"/apply-promo-code", postData);
    }

    downLoadPdf(postData): Observable<ArrayBuffer | any>{
      return this.http.post(this._baseURL+"/download-pdf-new", postData,{
        responseType: 'arraybuffer',
        observe: 'response'
      }).pipe(
        // The interceptor already handles blob-to-json error conversion.
        // So, you can directly check the headers here if needed,
        // or simply pass the data to the component.
        switchMap(response => this.handleResponse(response)),
        tap(response => console.log('Successfully received PDF array buffer')),
        catchError(error => this.handleError(error))
      );
    }

    private handleResponse(response: HttpResponse<ArrayBuffer>): Observable<ArrayBuffer> {
      const buffer = response.body as ArrayBuffer;

      if (isPdf(buffer)) {
        //console.log('Received PDF file based on content validation.');
        return new Observable<ArrayBuffer>(observer => {
          observer.next(buffer);
          observer.complete();
        });
      } else {
        // Decode the buffer to inspect the non-PDF content
        const decoder = new TextDecoder('utf-8');
        const text = decoder.decode(buffer);
        //console.error('Received non-PDF content.', text);
        //return throwError(() => new Error('Server returned an invalid file type.'));
        this.dataService.logFrontEndError('Server returned an invalid file type').subscribe();
        this.showToasterErrorMessage('Server returned an invalid file type');
      }
    }
  
  
    private handleError(error: any): Observable<never> {
      if (error instanceof HttpErrorResponse) {
          console.error('HTTP Error:', error.message);
          this.dataService.logFrontEndError(error.message).subscribe();
          return throwError(() => new Error('An HTTP error occurred.'));
      } else {
          // This is where the JSON from readJsonFromBuffer is caught
          console.error('API Message:', error);
          this.dataService.logFrontEndError(error.message).subscribe();
          return throwError(() => error.message); // Return just the error message from the JSON
      }
    }

    // private handleDownloadError(error: HttpErrorResponse): Observable<never> {
    //   console.error('An error occurred:', error.error);
    //   return throwError(() => new Error(error.error?.message || 'Server error occurred'));
    // }

    downLoadPreviewPdf(postData){
      return this.http.post(this._baseURL+"/download-pdf-preview", postData,{
        responseType: 'arraybuffer',
        observe: 'response'
      }).pipe(
        // The interceptor already handles blob-to-json error conversion.
        // So, you can directly check the headers here if needed,
        // or simply pass the data to the component.
        switchMap(response => this.handleResponse(response)),
        tap(response => console.log('Successfully received PDF array buffer')),
        catchError(error => this.handleError(error))
      );
    }

    downLoadWaterMarkDoc(postData){
      return this.http.post(this._baseURL+"/download-wm-doc", postData,{
        responseType: 'arraybuffer',
        observe: 'response'
      }).pipe(
        // The interceptor already handles blob-to-json error conversion.
        // So, you can directly check the headers here if needed,
        // or simply pass the data to the component.
        switchMap(response => this.handleResponse(response)),
        tap(response => console.log('Successfully received PDF array buffer')),
        catchError(error => this.handleError(error))
      );
    }

    getWatermarkDocList(hash){
      return this.http.get(this._baseURL+"/get-watermark-doc-list/"+hash);
    }
    storePDFtoExternalDrive(postData){
      return this.http.post(this._baseURL+"/store-pdf-to-external-drive", postData);
    }

    sendFreeFlowDoc(signee){
      return this.http.post(this._baseURL+"/template/send-free-flow-doc", signee);
    }
    transferOwnership(){
      return this.http.get(this._baseURL+"/transfer-ownership");
    }
    changeOwnership(email){
      return this.http.post(this._baseURL+"/change-ownership", email);
    }
    confirmOwnership(hash){
      return this.http.post(this._baseURL+"/ownership-confirmation", hash);
    }
    verifyAccount(hash){
      return this.http.post(this._baseURL+"/verify-account", {'hash' :hash});
    }
    unBlockSignatureRequestService(hash){
      return this.http.post(this._baseURL+"/unblock-signature-request", {'hash' :hash});
    }
    documentInfo(postData){
      return this.http.post(this._baseURL+"/getTemplateDataForHubspot", postData);
    }

    documentInfov1(postData){
      return this.http.post(this._baseURL+"/v1/getTemplateDataForHubspotv1", postData);
    }

    dealStageClosed(postData){
      return this.http.post(this._baseURL+"/gethubspotdealdata", postData);
    }

    syncPCMResult(postData){
      return this.http.post(this._baseURL+"/sync-postmapping-results", postData);
    }

    // documentInfov1(postData){
    //   return this.http.post(this._baseURL+"/v1/getTemplateDataForHubspot", postData);
    // }

    getWaterMarkTemplates(postData){
      return this.http.post(this._baseURL+"/getWaterMarkEnabledTemplates", postData);
    }

    getCompanyAuthenticatedForHubspot(postData){
      return this.http.post(this._baseURL+"/getHubSpotAuthenticationInfo", postData);
    }
    getHubSpotContacts(postData){
      return this.http.post(this._baseURL+"/getHubSpotContacts", postData);
    }

    getHubSpotMappingData(postData){
      return this.http.post(this._baseURL+"/get-mapping-data", postData);
    }

    getHubSpotMappingDatav1(postData){
      return this.http.post(this._baseURL+"/v1/get-mapping-data-v1", postData);
    }

    changeAssignee(postData){
      return this.http.post(this._baseURL+"/change-assignee", postData);
    }

    getRequestRedirectData(postData){
      return this.http.post(this._baseURL+"/getting-redirect-update", postData);
    }

    getLocalePosition(postData){
      return this.http.post(this._baseURL+"/updateViewHistory", postData);
    }
    checkUserDevice(postData){
      return this.http.post(this._baseURL+"/check-user-device", postData);
    }

    getDownloadKit(postData){
      return this.http.post(this._baseURL+"/template/get-kit-flow-doc", postData);
    }

    getMappingData(postData){
      return this.http.post(this._baseURL+'/get-hubspot-mapping-fields', postData);
    }

    getMappingDatav1(postData){
      return this.http.post(this._baseURL+'/v1/get-hubspot-mapping-fields', postData);
    }

    getMappingDataV1Signature(postData){
      return this.http.post(this._baseURL+'/v1/get-hubspot-mapping-fields-signature', postData);
    }

    async getMappingDataV2Signature(postData){
      return await this.http.post(this._baseURL+'/v1/get-hubspot-mapping-fields-signature', postData).toPromise();
    }

    savePreviewData(postData){
      return this.http.post(this._baseURL+'/savehubspotpreviewdata', postData);
    }

    getPreviewData(postData){
      return this.http.post(this._baseURL+'/gethubspotpreviewdata', postData);
    }

    getPreviewDefaultTemplateId(postData){
      return this.http.post(this._baseURL+'/getpreviewdefaulttemplateid', postData);
    }

    saveCustomProp(postData){
      return this.http.post(this._baseURL+'/custom-update-properties', postData);
    }

    downloadPreview(postData){
      return this.http.post(this._baseURL+"/download-preview", postData,{
        responseType: 'arraybuffer', observe: 'response'
      }).pipe(
        // The interceptor already handles blob-to-json error conversion.
        // So, you can directly check the headers here if needed,
        // or simply pass the data to the component.
        switchMap(response => this.handleResponse(response)),
        tap(response => console.log('Successfully received PDF array buffer')),
        catchError(error => this.handleError(error))
      );
    }

    getDealNameContract(postData){
      return this.http.post(this._baseURL+'/get-deal-name', postData);
    }

    getDealNameAndDocInfoPreview(postData){
      return this.http.post(this._baseURL+'/get-doc-info-preview', postData);
    }

    getGsuiteAuthSetting(postData){
      return this.http.post(this._baseURL+'/checkgsuitesettings', postData);
    }

    getGsuiteSendEmail(postData){
      return this.http.post(this._baseURL+'/send-download-preview', postData);
    }
    existingRequestInfo(postData){
      return this.http.post(this._baseURL+'/get-existing-request-info', postData);
    }

    existingRequestQuote(postData){
      return this.http.post(this._baseURL+'/get-existing-request-data', postData);
    }

    uploadDocumentMergeCRM(data){
      return this.http.post(this._baseURL+'/company/document/merge',data);
    }

    getexistingaddendumpdf(data){
      return this.http.post(this._baseURL+'/getexistingaddendumpdf',data);
    }

    deleteaddendum(data){
      return this.http.post(this._baseURL+'/deleteaddendum',data);
    }

    updateaddendumtitle(data){
      return this.http.post(this._baseURL+'/updateaddendumtitle',data);
    }

    uploadWaterMarkDocumentMergeCRM(data){
      return this.http.post(this._baseURL+'/company/document/watermarkmerge',data);
    }

    getExistingDocReplyPDF(data){
      return this.http.post(this._baseURL+'/get-existing-doc-reply',data);
    }

    deleteDocReplyPDF(data){
      return this.http.post(this._baseURL+'/deletedocreplypdf',data);
    }

    updateExistingDocReply(data){
      return this.http.post(this._baseURL+'/updatedocreplypdf',data);
    }

    storeRequestBasedComments(data){
      return this.http.post(this._baseURL+'/store-request-based-comments',data);
    }

    getCommentsByRequest(data){
      return this.http.post(this._baseURL+'/get-comments-by-request',data);
    }

    getDealPreFixInformation(data){
      return this.http.post(this._baseURL+'/template/get-deal-suffix',data);
    }

    getRelatedRequests(data){
      return this.http.post(this._baseURL+'/template/get-related-requests',data);
    }

    getRequestMappingData(data){
      return this.http.post(this._baseURL+'/get-request-mapping-data',data);
    }

    getRequestSavedScalingOptions(data){
      return this.http.post(this._baseURL+'/get-request-scaling-options',data);
    }

    markAsReadComments(data){
      return this.http.post(this._baseURL+'/mark-as-read-comments',data);
    }
    getDownloadButtonsEnable(data){
      return this.http.post(this._baseURL+'/get-downlaod-button-enable',data);
    }
    addCreditCard(postData){
      return this.http.post(this._baseURL+"/add-new-credit-card",postData);
    }

    getCustomerAllCards(postData){
      return this.http.post(this._baseURL+"/get-customer-cards",postData);
    }

    checkCardUsed(postData){
      return this.http.post(this._baseURL+"/check-card-used",postData);
    }

    deleteCardById(postData){
      return this.http.post(this._baseURL+"/delete-user-card",postData);
    }

    getStripePublishableKey(){
      var postData = {
        action: 'getguesttoken'
      }
      return this.http.post(this._baseURL+"/get-publishable-key",postData);
    }

    resendDownloadLink(postData){
      return this.http.post(this._baseURL+'/resend-download-link', postData);
    }

    decodeEmailVerificationHash(hash,type=0){
      return this.http.post(this._baseURL+"/verify-user-newemail", {"hash":hash,"type":type});
    }
    doSendFreeEmail(postData){
      return this.http.post(this._baseURL+"/send-free-flow-email", postData);
    }

    getExistingRequest(postData){
      return this.http.post(this._baseURL+'/get-existing-template-request', postData);
    }

    ruleResult(postData){
      return this.http.post(this._baseURL+'/rule-result-by-request-id', postData);
    }

    addBankAccountDetails(postData){
      return this.http.post(this._baseURL+'/add-user-bank-account', postData);
    }

    getBankAccountDetails(postData){
      return this.http.post(this._baseURL+'/get-bank-account-details', postData);
    }

    verifyBankAccountDetails(postData){
      return this.http.post(this._baseURL+'/verify-bank-account-details', postData);
    }

    decodeVerificationACHHash(hash){
      return this.http.get(this._baseURL+"/verify-ach-details/"+hash);
    }

    getCompanyListForStripe(){
      return this.http.get(this._baseURL+"/get-company-list-for-stripe");
    }

    getCustomerAllCardsForCompany(postData){
      return this.http.post(this._baseURL+"/get-customer-cards-for-company",postData);
    }

    createCommentThread(postData){
      return this.http.post(this._baseURL+'/store-comments-doc-based',postData);
    }

    updateCommentThread(postData){
      return this.http.post(this._baseURL+"/update-doc-comment",postData);
    }

    getthreadMessages(request_id,user_doc_id,user_id){
      return this.http.get(this._baseURL+"/get-comments-doc-based/"+request_id+"/"+user_doc_id+"/"+user_id);
    }

    pagesDocumentData(postData){
      return this.http.post(this._baseURL+"/get-pages-document-data",postData);
    }

    deleteComment(postData){
      return this.http.post(this._baseURL+"/delete-doc-comment",postData);
    }

    deleteUserSignature(postData){
      return this.http.post(this._baseURL+"/delete-user-signature",postData);
    }
    getOpenDealRequest(deal_id,doc_id,quote_no?,action_panel?){
      return this.http.get(this._baseURL+"/get-open-requests/"+deal_id+"/"+doc_id+"/"+quote_no+"/"+action_panel);
    }
    markOfflineUpload(postData){
      return this.http.post(this._baseURL+"/mark-offline",postData);
    }
    uploadOfflinePDF(postData){
      return this.http.post(this._baseURL+"/upload-off-sign-doc",postData);
    }
    getDealHubConfiguration(company_id){
      return this.http.post(this._baseURL+"/get-company-dealhub-configuration",company_id);
    }
    getDealHubInfoHash(postData){
      return this.http.post(this._baseURL+'/get-dealhub-info-by-hash',postData);
    }
    updateProductQuantity(postData){
      return this.http.post(this._baseURL+"/update-lineitems-for-deal",postData);
    }
    sendDealHubMessage(postData){
      return this.http.post(this._baseURL+"/send-dealhub-message",postData);
    }
    saveDealHubProgress(postData){
      return this.http.post(this._baseURL+"/save-dealhub-progress",postData);
    }
    saveHubSpotAndCustomFields(postData){
      return this.http.post(this._baseURL+"/save-dealhub-customfields", postData);
    }
    getsavedDealHubCustomFields(postData){
      return this.http.post(this._baseURL+"/get-dealhub-customfields", postData);
    }
    sendRequestDealHub(postData){
      return this.http.post(this._baseURL+"/create-send-dealhub-request", postData);
    }

    getSubscriptionData(postData){
      return this.http.post(this._baseURL+"/company-payments",postData);
    }
    approveDownloads(hashKey){
      return this.http.get(this._baseURL+"/approvedownloads/"+hashKey);
    }

    createDeal(postData){
      return this.http.post(this._baseURL+"/create-deal",postData);
    }

    saveProductsAndDiscounts(postData){
      return this.http.post(this._baseURL+"/save-products-and-discounts",postData);
    }

    saveHubSpotFields(postData){
      return this.http.post(this._baseURL+'/save-dealhub-hubspot-fields-data', postData);
    }

    getSavedHubSpotFields(postData){
      return this.http.post(this._baseURL+'/get-dealhub-hubspot-fields-data', postData);
    }

    createNewDealAutomatic(postData){
      return this.http.post(this._baseURL+"/create-deal",postData);
    }

    searchCompanyDeals(postData){
      return this.http.post(this._baseURL+"/search-company-deal", postData);
    }

    getYouniumAccounts(postData){
      return this.http.post(this._baseURL+"/get-younium-accounts", postData);
    }

    getfilterAccounts(postData){
      return this.http.post(this._baseURL+"/filter-younium-accounts", postData);
    }

    getDealProperties(postData){
      return this.http.post(this._baseURL+"/get-deal-properties", postData);
    }

    getProductsCount(postData){
      return this.http.post(this._baseURL+"/get-product-count", postData);
    }


    getDealHubSigningLink(postData){
      return this.http.post(this._baseURL+'/get-dealhub-signing-link',postData);
    }

    createDealHubURL(postData){
      return this.http.post(this._baseURL+'/create-dealhub-review-link',postData);
    }

    getUserDigitalConsent(postData){
      return this.http.post(this._baseURL+'/get-user-digital-consent', postData);
    }

    viewdealhubHistory(postData){
      return this.http.post(this._baseURL+'/get-dealhub_history', postData);
    }

    serachHubSpotProducts(postData){
      return this.http.post(this._baseURL+'/v1/products-search', postData);
    }
    approvalList(user_id){
      return this.http.get(this._baseURL+"/get-approval-listing/"+user_id);
    }
    getCompanyProperties(postData){
      return this.http.post(this._baseURL+"/engagement-company",postData);
    }
    sendSlackNotification(postData){
      return this.http.post(this._baseURL+'/send-slack-notification', postData);
    }
    checkReviewerDigitalConsent(postData){
      return this.http.post(this._baseURL+'/check-reviewer-digital-consent', postData);
    }

    getCompanyDeals(postData){
      return this.http.post(this._baseURL+'/get-company-deals', postData);
    }
    simplyfynumber(op,type=0){
      let plainop1Number:any;
      if(type == 1){
        if(op!=null){
          op=op.toString().replace("$", "");
          plainop1Number = op.toString().replace(",", "");
          let result = plainop1Number.indexOf(".00");
          if (result == -1) {
              var extract_number = plainop1Number.split(".00");
              plainop1Number = extract_number[0];
          }
        }
      } else {
        if(op!=null){
          op=op.toString().replace("$", "");
          plainop1Number = op.toString().replace(",", "");
        }
      }
      return plainop1Number;
    }

    //oprator function to compare values
    equals(op1,op2)
    {
      if(op1 != '' && op2 != ''){
          if(!isNaN(parseFloat(op1))) {
          //if(!isNaN($op1) || is_float($op1)){
            return Number((op1).toFixed(2)) == Number((op2).toFixed(2));
              //return round(op1, 2) == round(op2, 2);
          } else {
              return op1 == op2;
          }
      } else {
          return op1 == op2;
      }
    }

    does_not_equal(op1,op2)
    {
      if(op1 != '' && op2 != ''){
          if(!isNaN(parseFloat(op1))) {
          //if(is_numeric(op1) || is_float(op1)){
            return Number((op1).toFixed(2)) != Number((op2).toFixed(2));
            //return round(op1, 2) != round(op2, 2);
          } else {
              op1 = op1.toLowerCase();
              op2 = op2.toLowerCase();
              //op1 = strtolower(op1);
             // op2 =  strtolower(op2);
              return op1 != op2;
          }
      } else {
          return op1 != op2;
      }
    }

    is_greater_than(op1,op2)
    {
      if(op1 != '' && op2 != ''){
          if(!isNaN(parseFloat(op1))) {
          //if(is_numeric(op1) || is_float(op1)){
            return Number((op1).toFixed(2)) > Number((op2).toFixed(2));
              //return round(op1, 2) > round(op2, 2);
          } else {
              return op1 > op2;
          }
      } else {
          return op1 > op2;
      }
    }

    is_less_than(op1,op2)
    {
      if(op1 != '' && op2 != ''){
          if(!isNaN(parseFloat(op1))) {
            return Number((op1).toFixed(2)) < Number((op2).toFixed(2));
              //return round($op1, 2) < round($op2, 2);
          } else {
              return op1 < op2;
          }
      } else {
          return op1 < op2;
      }

    }



    getCompanyRecentDeals(data){
      return this.http.post(this._baseURL+'/get-company-recent-deals',data);
    }

    doCleanWithDeal(data){
      return this.http.post(this._baseURL+'/cleanup-deal',data);
    }

    updateCleanUpDeal(data){
      return this.http.post(this._baseURL+'/update-deal-cleanup',data);
    }

    getDealRquestData(data){
      return this.http.post(this._baseURL+'/get-deal-request-data',data);
    }
    getSendDealHubRequest(postData){
      return this.http.post(this._baseURL+"/check-user-deal", postData);
    }

    createDealwithDraft(postData){
      return this.http.post(this._baseURL+"/create-deal", postData,{
        responseType: 'arraybuffer',observe: 'response',
      }).pipe(
        // The interceptor already handles blob-to-json error conversion.
        // So, you can directly check the headers here if needed,
        // or simply pass the data to the component.
        switchMap(response => this.handleResponse(response)),
        tap(response => console.log('Successfully received PDF array buffer')),
        catchError(error => this.handleError(error))
      );
    }

    getOfflineRequestStatus(postData){
      return this.http.post(this._baseURL+"/get-offline-request-status", postData);
    }

    sendDealHubManualReminder(postData){
      return this.http.post(this._baseURL+"/send-manual-reminder-fordealhub", postData);
    }

    async getLoggedInPaidUser(){
      return await this.http.get(this._baseURL+"/check-is-paid-user").toPromise();
    }

    getTemplateBlocks(postData){
      return this.http.post(this._baseURL+'/get-template_fixed-custom-blocks', postData);
    }
    resendDealHubRequest(postData){
      return this.http.post(this._baseURL+'/resend-dealhub-link',postData);
    }
    createCRMNewQuote(postData){
      return this.http.post(this._baseURL+'/create-deal-request',postData);
    }

    checkFileType(postData){
      return this.http.post(this._baseURL+'/getFileType',postData);
    }

    formatDate(date,add?) {
      //console.log("Before ----- Date",date);
      if(add==1){
        var d = new Date(date),month = '' + (d.getMonth() + 1),day = '' + d.getDate(),year = (d.getFullYear() + 1);
      }else{
        var d = new Date(date),month = '' + (d.getMonth() + 1),day = '' + d.getDate(),year = d.getFullYear();
      }
      if (month.length < 2) month = '0' + month;
      if (day.length < 2) day = '0' + day;
      //console.log("After ----- Date",month,day,year);
      return [month,day,year].join('/');
    }
    
    
    formatDateExpirationAddDate(date,add?) {
      var dd = new Date(date),month = '' + (dd.getMonth() + add),day = '' + dd.getDate(),year = dd.getFullYear();
      if (month.length < 2) month = '0' + month;
      if (day.length < 2) day = '0' + day;
  
      return [month,day,year].join('/');
    }

    movetoVoidStage(data){
      return this.http.post(this._baseURL+'/update-deal-stage',data);
    }

    getSimilarDealInfoDetails(hashKey){
      return this.http.get(this._baseURL+"/similar-deals-detail/"+hashKey);
    }

    getWaterMarkTemplatesListing(postData){
      return this.http.post(this._baseURL+"/get-wm-enabled-templates-list", postData);
    }

    openWaterMarkDocsApprovalHash(hashKey){
      return this.http.get(this._baseURL+"/water-markdoc-approval/"+hashKey);
    }

    getCustomObjectProperties(postData){
      return this.http.post(this._baseURL+"/get-custom-object-properties", postData);
    }

    getAllCustomObjectsList(postData){
      return this.http.post(this._baseURL+"/get-all-custom-objects", postData);
    }

    async getDealPropertiesWait(postData){
      return await this.http.post(this._baseURL+"/get-deal-properties", postData).toPromise();
    }
    getUploadDocHash(hashKey){
      return this.http.get(this._baseURL+"/company/documents/requestdoclist/"+hashKey);
    }
    groupDocumentUpload(postData){
      return this.http.post(this._baseURL+"/company/documents/upload/",postData);
    }

    getUploadedChecks(hashKey){
      return this.http.get(this._baseURL+"/company/documents/uploaded/"+hashKey);
    }
    saveDealHubPreviewSettings(postData){
      return this.http.post(this._baseURL+"/save-dealhub-preview-settings",postData);
    }
}
